import * as React from 'react'
import MessageListener, {
  MessageListenerOwnProps,
} from '@/modules/shared/components/MessageListener'
import { useMessageStore } from '@/modules/shared/stores/messageStore'

/**
 * Wcześniej `connect` z `pure: false` nad slice'em `messages`.
 * Store zawsze ustawia nowy obiekt komunikatu, więc nieczysty tryb nie jest już
 * potrzebny - zmiana referencji sama wywołuje render.
 */
const MessageListenerContainer: React.FC<MessageListenerOwnProps> = (props) => {
  const message = useMessageStore((state) => state.message)

  return <MessageListener {...props} message={message} />
}

export default MessageListenerContainer
